import { PopupModal } from "components/modals/ModalBox";
import React from "react";
import useButtonLoader from "hooks/useButtonLoader";
import { changeStatusUserAPI } from "services/user";
import { toastMessage } from "utils/toastMessage";
import { updateReportApi } from "services/report";

const ChangeSelectedUserStatus = ({
  selectedUserDetail,
  onClose,
  setUserList,
  userStatusModal,
  refetchUserList
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // change delete handler
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const reqData = {
        _id: selectedUserDetail?._id || "",
        type: "FEED",
        status: selectedUserDetail?._feed.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const { data: responseData, status } = await updateReportApi(reqData);
      if (status === 200) {
        refetchUserList()
        onClose();
        toastMessage(responseData.message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  console.log({selectedUserDetail});
  

  return (
    <>
      <PopupModal
        show={userStatusModal}
        handleClose={onClose}
        content={`If you delete this post then this will be hide from the platform.`}
        title={`Are you sure you want to ${selectedUserDetail?._feed.status === "ACTIVE" ? "delete" : "recover"} this post?`}
        buttonLoader={buttonLoader}
        action={changeStatusHandler}
      />
    </>
  );
};

export default ChangeSelectedUserStatus;
